var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlayValuePlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 4233.32 4233.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor",
      fillRule: "nonzero"
    },
    d: "M2116.63 3527.87c-777.9,0 -1411.18,-633.28 -1411.18,-1411.18 0,-777.89 633.28,-1411.18 1411.18,-1411.18 777.89,0 1411.18,633.29 1411.18,1411.18 0,777.9 -633.29,1411.18 -1411.18,1411.18l0 0zm0 -3175.1c-973.97,0 -1763.86,789.89 -1763.86,1763.92 0,973.97 789.89,1763.86 1763.86,1763.86 974.03,0 1763.92,-789.89 1763.92,-1763.86 0,-974.03 -789.89,-1763.92 -1763.92,-1763.92l0 0zm176.4 881.96l-352.81 0 0 705.56 -705.56 0 0 352.81 705.56 0 0 705.56 352.81 0 0 -705.56 705.56 0 0 -352.81 -705.56 0 0 -705.56z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayValuePlus);
export default __webpack_public_path__ + "static/media/icon-play-value-plus.bc5e45c288b31cd7b281eba85ff3f7b1.svg";
export { ForwardRef as ReactComponent };